import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    style: style
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5.58929 5.00003L9.87799 0.711326L9.28874 0.12207L5.00003 4.41078L0.711326 0.12207L0.12207 0.711326L4.41078 5.00003L0.12207 9.28874L0.711326 9.87799L5.00003 5.58929L9.28874 9.87799L9.87799 9.28874L5.58929 5.00003Z",
    fill: "white"
  }));
};
export default SVGComponent;